import { defineMessages } from 'react-intl';

export const administrationMessages = defineMessages({
    sites: {
        id: 'sites',
        defaultMessage: 'Sites',
    },
    organisations: {
        id: 'organisations',
        defaultMessage: 'Organisations',
    },
    zones: {
        id: 'zones',
        defaultMessage: 'Zones',
    },
    gateways: {
        id: 'gateways',
        defaultMessage: 'Gateways',
    },
    spaces: {
        id: 'spaces',
        defaultMessage: 'Spaces',
    },
    roles: {
        id: 'roles',
        defaultMessage: 'Roles',
    },
    users: {
        id: 'users',
        defaultMessage: 'Users',
    },
    pricingPlans: {
        id: 'pricing-plans',
        defaultMessage: 'Pricing plans',
    },
    troubleshooting: {
        id: 'troubleshooting',
        defaultMessage: 'Troubleshooting',
    },
    actions: {
        id: 'actions',
        defaultMessage: 'Actions',
    },
    prices: {
        id: 'prices',
        defaultMessage: 'Prices',
    },
    systems: {
        id: 'systems',
        defaultMessage: 'Systems',
    },
    settings: {
        id: 'settings',
        defaultMessage: 'Settings',
    },
    components: {
        id: 'components',
        defaultMessage: 'Components',
    },
    billingSettings: {
        id: 'billing-settings',
        defaultMessage: 'Billing settings',
    },
    validatorAccounts: {
        id: 'validator-accounts',
        defaultMessage: 'Validator accounts',
    },
    validations: {
        id: 'validations',
        defaultMessage: 'Validations',
    },
    validationTypes: {
        id: 'validation-types',
        defaultMessage: 'Validation types',
    },
});
